export default __webpack_public_path__ + "static/media/staff3.29ad2882.jpeg";